import { useNavigate } from "react-router-dom";
import "./NotificationModal.css";

const NotificationModal = ({
  isOpen,
  onClose,
  type = "success",
  message,
  title,
  buttonText,
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const isSuccess = type === "success";
  const isFeedback = type === "feedback";

  const defaultTitle = isSuccess
    ? "Successfully registered for this event"
    : isFeedback
      ? "Feedback Successfully Submitted"
      : "Email Already Registered";

  const defaultMessage = isSuccess
    ? "We have sent you an email with the event details"
    : isFeedback
      ? "Thank you for your valuable feedback"
      : "This email is already associated with an existing user role. Please use a different email address.";

  const defaultButtonText = isSuccess ? "Back To Events" : "OK";

  const handleButtonClick = () => {
    const finalButtonText = buttonText || defaultButtonText;
    if (finalButtonText === "Back To Events") {
      navigate("/");
    }
    onClose();
  };

  return (
    <div className="notification-modal-overlay" onClick={onClose}>
      <div
        className="notification-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="notification-modal-close" onClick={onClose}>
          ×
        </button>

        <div
          className={`notification-modal-icon ${isSuccess ? "success" : "error"}`}
        >
          {isSuccess ? (
            // Success Icon
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="75"
              height="75"
              viewBox="0 0 75 75"
              fill="none"
            >
              <path
                d="M34.6018 2.49869C36.2672 1.06288 38.7328 1.06287 40.3982 2.49868L46.6142 7.85786C47.4354 8.56591 48.4875 8.94883 49.5717 8.93432L57.7783 8.82452C59.9769 8.79511 61.8657 10.38 62.2185 12.5503L63.5355 20.6513C63.7095 21.7216 64.2692 22.6912 65.1091 23.377L71.4663 28.5679C73.1695 29.9587 73.5976 32.3868 72.4728 34.2762L68.2745 41.3284C67.7198 42.2601 67.5254 43.3627 67.7279 44.428L69.2611 52.4908C69.6719 54.6509 68.4391 56.7862 66.3629 57.5106L58.6138 60.2142C57.5899 60.5714 56.7323 61.291 56.2027 62.2373L52.1946 69.3992C51.1207 71.3181 48.8038 72.1613 46.7478 71.3817L39.0737 68.4717C38.0598 68.0873 36.9402 68.0873 35.9263 68.4717L28.2522 71.3817C26.1962 72.1613 23.8793 71.3181 22.8055 69.3992L18.7973 62.2373C18.2677 61.291 17.4101 60.5714 16.3862 60.2142L8.63706 57.5106C6.56093 56.7862 5.32812 54.6509 5.73888 52.4908L7.27206 44.428C7.47463 43.3627 7.28022 42.2601 6.72553 41.3284L2.52717 34.2762C1.40236 32.3868 1.83051 29.9587 3.5337 28.5679L9.89085 23.377C10.7308 22.6912 11.2905 21.7216 11.4645 20.6513L12.7815 12.5504C13.1343 10.38 15.0231 8.79511 17.2217 8.82452L25.4283 8.93432C26.5125 8.94883 27.5646 8.56591 28.3858 7.85786L34.6018 2.49869Z"
                fill="#0CC0A0"
              />
              <path
                d="M37.572 41.0123L39.0712 42.5725C39.4647 42.982 40.1198 42.982 40.5133 42.5725L51.9482 30.6717C52.579 30.0151 53.6294 30.0151 54.2603 30.6717C54.8565 31.2922 54.8565 32.2728 54.2603 32.8933L41.2344 46.45C40.4474 47.2691 39.1371 47.2691 38.3501 46.45L30.8528 38.6472C30.2565 38.0267 30.2565 37.0461 30.8528 36.4256C31.4836 35.769 32.534 35.769 33.1649 36.4256L35.3502 38.6999L37.572 41.0106V41.0123ZM38.6393 37.4918C38.0448 36.8731 38.0448 35.8954 38.6392 35.2766L44.2089 29.4788C44.838 28.824 45.8855 28.8239 46.5146 29.4787C47.1091 30.0974 47.1092 31.0751 46.5147 31.6939L40.945 37.4917C40.316 38.1466 39.2685 38.1466 38.6393 37.4918ZM32.0634 44.5286C32.6592 45.1487 32.6592 46.1285 32.0634 46.7486C31.433 47.4047 30.3833 47.4047 29.7529 46.7486L21.9687 38.6472C21.3724 38.0267 21.3724 37.0461 21.9687 36.4256C22.5996 35.769 23.6499 35.769 24.2808 36.4256L25.3466 37.5347L25.345 37.5364L32.0634 44.5286Z"
                fill="white"
              />
            </svg>
          ) : (
            // Error/Warning Icon
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="75"
              height="75"
              viewBox="0 0 75 75"
              fill="none"
            >
              <path
                d="M34.6018 2.49869C36.2672 1.06288 38.7328 1.06287 40.3982 2.49868L46.6142 7.85786C47.4354 8.56591 48.4875 8.94883 49.5717 8.93432L57.7783 8.82452C59.9769 8.79511 61.8657 10.38 62.2185 12.5503L63.5355 20.6513C63.7095 21.7216 64.2692 22.6912 65.1091 23.377L71.4663 28.5679C73.1695 29.9587 73.5976 32.3868 72.4728 34.2762L68.2745 41.3284C67.7198 42.2601 67.5254 43.3627 67.7279 44.428L69.2611 52.4908C69.6719 54.6509 68.4391 56.7862 66.3629 57.5106L58.6138 60.2142C57.5899 60.5714 56.7323 61.291 56.2027 62.2373L52.1946 69.3992C51.1207 71.3181 48.8038 72.1613 46.7478 71.3817L39.0737 68.4717C38.0598 68.0873 36.9402 68.0873 35.9263 68.4717L28.2522 71.3817C26.1962 72.1613 23.8793 71.3181 22.8055 69.3992L18.7973 62.2373C18.2677 61.291 17.4101 60.5714 16.3862 60.2142L8.63706 57.5106C6.56093 56.7862 5.32812 54.6509 5.73888 52.4908L7.27206 44.428C7.47463 43.3627 7.28022 42.2601 6.72553 41.3284L2.52717 34.2762C1.40236 32.3868 1.83051 29.9587 3.5337 28.5679L9.89085 23.377C10.7308 22.6912 11.2905 21.7216 11.4645 20.6513L12.7815 12.5504C13.1343 10.38 15.0231 8.79511 17.2217 8.82452L25.4283 8.93432C26.5125 8.94883 27.5646 8.56591 28.3858 7.85786L34.6018 2.49869Z"
                fill="#EF4444"
              />
              <path
                d="M37.5 25C37.5 23.6193 38.6193 22.5 40 22.5C41.3807 22.5 42.5 23.6193 42.5 25V40C42.5 41.3807 41.3807 42.5 40 42.5C38.6193 42.5 37.5 41.3807 37.5 40V25ZM40 52.5C41.3807 52.5 42.5 51.3807 42.5 50C42.5 48.6193 41.3807 47.5 40 47.5C38.6193 47.5 37.5 48.6193 37.5 50C37.5 51.3807 38.6193 52.5 40 52.5Z"
                fill="white"
              />
            </svg>
          )}
        </div>

        <div className="notification-modal-text">
          <h2 className="notification-modal-title">{title || defaultTitle}</h2>
          <p className="notification-modal-message">
            {message || defaultMessage}
          </p>
        </div>

        <button
          className="notification-modal-button"
          onClick={handleButtonClick}
        >
          {buttonText || defaultButtonText}
        </button>
      </div>
    </div>
  );
};

export default NotificationModal;
